import { whiteColor, primaryColor } from 'assets/jss/material-dashboard-pro-react';

const prepaidLoyaltyAddNewServicesStyle = (theme) => ({
	tableStyle: {
		borderCollapse: 'separate',
		borderSpacing: '0 10px',
		'&:last-child': {
			padding: '0px',
		},
	},
	tableCellStyle: {
		whiteSpace: 'nowrap',
		border: 'hidden',
		backgroundColor: whiteColor,
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		cursor: 'pointer',
		'&:first-child': {
			display: 'flex',
			paddingRight: '0px',
			borderTopLeftRadius: 8,
			borderBottomLeftRadius: 8,
		},
		'&:nth-child(2)': {
			maxWidth: '110px',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			'& p': {
				textOverflow: 'ellipsis',
				overflow: 'hidden',
			},
		},
		'&:last-child': {
			maxWidth: '100px',
			paddingLeft: '0',
			overflow: 'hidden',
			textOverflow: 'ellipsis',
			whiteSpace: 'nowrap',
			borderTopRightRadius: 8,
			borderBottomRightRadius: 8,
			'& p': {
				textOverflow: 'ellipsis',
				overflow: 'hidden',
			},
		},
	},
	tabsButtons: {
		display: 'flex',
		flexDirection: 'row-reverse',
		marginTop: 24,
		'& > :first-child': {
			margin: '0 0 0 8px',
		},
	},
	tabsButtonsIn: {
		backgroundColor: whiteColor,
		marginTop: 0,
		paddingRight: '32px',
		paddingBottom: '32px',
		width: '60%',
		margin: '0 auto',
		borderBottomLeftRadius: '8px',
		borderBottomRightRadius: '8px',
		[theme.breakpoints.down('xs')]: {
			width: '100%',
		},
	},
	right: {
		textAlign: 'right',
	},
	nextButton: {
		width: 120,
	},
	confirmPaymentButton: {
		width: 168,
	},
	searchIcon: {
		height: '16px',
		width: 'auto',
	},
	creditCardContainer: {
		textAlign: 'left',
		margin: '0 auto',
		width: '80%',
		display: 'flex',
		flexDirection: 'column',
	},
	servicesTabSelect: {
		marginBottom: '8px',
		marginTop: '32px',
	},
	selectedSingleItem: {
		borderRadius: '8px',
		border: `2px solid ${primaryColor[0]}`,
	},
	topupBanner: {
		minHeight: '50px',
	},
});

export default prepaidLoyaltyAddNewServicesStyle;
